import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  walletAddress: "",
  refAddress: "",
  isLoggedIn: false,
  jwt: "",
  userinfo: {},
};
const WalletSlice = createSlice({
  name: "WallelSlice",
  initialState: { ...initialState },
  reducers: {
    setWalletAddress: (state, action) => {
      state.walletAddress = action.payload;
    },
    setRefAddress: (state, action) => {
      state.refAddress = action.payload;
    },
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setUserInfo: (state, action) => {
      state.userinfo = action.payload;
      if (action.payload?.user) state.walletAddress = action.payload?.user;
    },
    setToken: (state, action) => {
      state.jwt = action.payload;
    },
  },
});

export const {
  setWalletAddress,
  setRefAddress,
  setIsLoggedIn,
  setToken,
  setUserInfo,
} = WalletSlice.actions;

export default WalletSlice.reducer;
